export enum SettingsRoutes {
  Index = '/settings/index',
  Languages = '/receive/languages',
}
